module.exports = __webpack_public_path__ + "img/8B.23db9b0e.png";